//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showIntroBubble: true,
            showCorrectBubble: false,
            showIncorrectBubble: false,
            numbers: [
                {
                    num: '112',
                    correct: true,
                    clicked: false
                },
                {
                    num: '456',
                    correct: false,
                    clicked: false
                },
                {
                    num: '199',
                    correct: false,
                    clicked: false
                },
                {
                    num: '222',
                    correct: false,
                    clicked: false
                },
                {
                    num: '300',
                    correct: false,
                    clicked: false
                },
                {
                    num: '144',
                    correct: true,
                    clicked: false
                },
                {
                    num: '822',
                    correct: false,
                    clicked: false
                },
                {
                    num: '000',
                    correct: false,
                    clicked: false
                }
            ]
        };
    },

    computed: {
        numCorrect () {
            return this.numbers.filter(number => number.correct && number.clicked).length;
        },
        maxCorrect () {
            return this.numbers.filter(number => number.correct).length;
        },
        numWrong () {
            return this.numbers.filter(number => !number.correct && number.clicked).length;
        },
        result () {
            return this.$game.getMultipleChoiceResult(this.numCorrect, this.maxCorrect, this.numWrong);
        }
    },

    methods: {
        setAnswer (number) {
            this.showIntroBubble = false;
            this.showCorrectBubble = false;
            this.showIncorrectBubble = false;

            number.clicked = true;

            if (number.correct) {
                this.showCorrectBubble = true;
            } else if (!number.correct) {
                this.showIncorrectBubble = true;
            }
        },
        getButtonType (number) {
            if (number.correct && number.clicked) {
                return 'success';
            } else if (!number.correct && number.clicked) {
                return 'danger';
            } else {
                return 'light';
            }
        }
    }
};
